import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}];
export function Footer() {
  return <footer className="bg-azul" data-id="element-69" data-mp="32pfc42m3b1ty">
      <div className="mx-auto max-w-2xl px-4 py-5 pb-20 text-center sm:pb-5" data-id="element-70" data-mp="36pfsvtwnvp46">
        <p className="text-xs text-blanco/85" data-id="element-71" data-mp="36nd57gize82m">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-1.5 text-[0.68rem] leading-snug text-blanco/70" data-id="element-72" data-mp="3uftm3nqzfu0c">
          {PRODUCT_NAME} es un producto educativo de desarrollo y organización
          personal. No sustituye atención médica, psicológica, psiquiátrica,
          financiera ni ningún otro servicio profesional. Los resultados dependen
          de cada persona, su situación y la aplicación que realice del material.
        </p>
        <p className="mt-1.5 text-xs text-blanco/85" data-id="element-73" data-mp="2a19tpmiidoxa">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-dorado underline-offset-2 transition-colors duration-150 ease-soft hover:text-blanco hover:underline" data-id="element-74" data-mp="2ezuv3p9hyenb">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5" data-id="element-75" data-mp="3v89fujfim3iz">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-blanco/85" data-id="element-76" data-mp="3v5df6nca90qu">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-77" data-mp="81yvyfozns2e" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-78" data-mp="34gxjj8lkv8n">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-soft hover:text-dorado" data-id="element-79" data-mp="33noucq2vvnv">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}